module.exports = __webpack_public_path__ + "static/img/fjdjt.38d9c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/fjdjt.jpg
// module id = 46B6
// module chunks = 0